<div class="page-padding">

    <div class="panel__header">
        <span class="panel__header__title custom-title">{{title | translate | async}}</span>
    </div>
  <div class="step-container">

    <div style="display: flex; flex-direction: column ;width: 50%;">
        <span style=" font-weight: bold;">1. {{"Customer and Jobsite Selection" | translate | async}}</span>
        <div style="display: flex; flex-direction: row;margin-top: 1%;">
            <mat-form-field style="width: 100%">
                <mat-select id="customer" [(ngModel)]="selectedCustomer" [placeholder]="'Select Customer' | translate | async"
                    (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl required>
                    <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
                        {{customer.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 100%">
                <mat-select id="jobsite" [placeholder]="'Select Job Site' | translate | async" [(ngModel)]="selectedJobsite"
                    (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl required>
                    <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                        {{jobsite.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div style="padding-left: 30%;  position: absolute;left: 50%; margin-top: -2%;">
                <input hidden type='file' (change)="onSelectImplementPhoto($event)"
                    #uploadImplementImage>
                            <!-- <div *ngIf="photoLoading">
                                <mat-spinner></mat-spinner>
                                </div> -->
                <ng-container *ngIf="!implementImage && !photoLoading">
                    <div class="add-implement-image-container" (click)="uploadImplementImage.click()">
                        <i class="material-icons add-implement-image-icon">add_box</i>
                        <div class="add-implement-image-label">{{"Add Implement Image" | translate | async}}</div>
                    </div>
                </ng-container>

                <ng-container *ngIf="implementImage?.length > 0">
                    <div class="implement-image-container image-offset-left">
                              <div *ngIf="photoLoading">
                                <mat-spinner></mat-spinner>
                                </div>
                        <img [src]="getImage(implementImage)" *ngIf="!photoLoading"
                            style="width: 200px;height: 200px; margin-top: -6%;"
                            (click)="openEnlargedImage(implementImage, 1)"
                            matTooltip="Click to view enlarged image." />
                        <div>
                            <button mat-raised-button style="background:white "
                                (click)="uploadImplementImage.click()" >{{'Update Image' | translate | async}}</button>
                            <button *ngIf="!isNewImplement" mat-raised-button
                                (click)="deleteImplementImage()" style="margin-left: 3px;">
                                {{'Delete Image' | translate | async}}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>


    <div style="margin-top: 1%;margin-bottom: 0;">
        
        <mat-radio-group [(ngModel)]="equipmentOrInventory">
            <mat-radio-button [value]="1" (change)="loadOntoEquipment()" labelPosition="before">
                <b>2. {{'Add to Equipment' | translate | async}}</b></mat-radio-button>
            <mat-radio-button [value]="2" (change)="createInInventory()" labelPosition="before"><b>
                {{'Jobsite Inventory' | translate | async}}</b></mat-radio-button>
            <mat-radio-button [value]="3" (change)="createInTemplate()" labelPosition="before"><b>{{'Template' | translate | async}}
                </b></mat-radio-button>
        </mat-radio-group>
    </div>

    <div *ngIf="equipmentOrInventory==1"
        style="display: flex; flex-direction: row;margin-top: 1%; width: 50%;">

        <mat-form-field style="width: 100%">
            <mat-select id="jobsite" [placeholder]="'Serial / Unit Number' | translate | async" [(ngModel)]="selectedEquipment"
                ngDefaultControl required (selectionChange)="onSelectEquipment()">
                <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 100%">
            <input matInput [placeholder]="'Equipment SMU at Initial Install' | translate | async" type="number"
                [(ngModel)]="equipmentSMU" (keypress)="ValidateNumberInputs($event)" ngDefaultControl
                 [disabled]="!canChangeHoursAndDate">
            <span matSuffix>{{'Hours' | translate | async}}</span>
        </mat-form-field>
    </div>

    <div style="display: flex; flex-direction: row;margin-top: 1%; width: 75%;">

        <mat-form-field style="width: 100%;">
            <mat-select id="select-family" [placeholder]="'Select Family' | translate | async" [(ngModel)]="selectedFamily"
                (selectionChange)="LoadModels()" ngDefaultControl multiple>
                <mat-option [value]="type.Id"
                    *ngFor="let type of _favouriteDialogService.availableFamilyList">
                    {{type.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 100%;">
            <mat-select id="select-family" [placeholder]="'Select Make' | translate | async" [(ngModel)]="selectedMakes"
                (selectionChange)="LoadModels()" ngDefaultControl multiple>
                <mat-option [value]="make.Id" *ngFor="let make of makeList">
                    {{make.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 100%;">
            <mat-select id="select-family" [placeholder]="'Select Model' | translate | async" [(ngModel)]="selectedModels"
                ngDefaultControl required multiple>
                <mat-option [value]="model.Id" *ngFor="let model of modelList_">
                    {{model.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

    </div>


    <div style="display: flex; flex-direction: column ;width: 78%;">
        <span style=" font-weight: bold;">3. {{"Implement Definition" | translate | async}}</span>
        <div style="display: flex; flex-direction: row;margin-top: 1%;">
            
            
           
                <mat-form-field style="width: 100%">
                    <mat-select [placeholder]="'Select Asset Type' | translate | async" [(ngModel)]="selectTypeId" name="GETType" (selectionChange)="ChangeType()">
                      <mat-option *ngFor="let type of GETTypeList" [value]="type.Id">{{type.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>

            <mat-form-field style="width: 100%">
                <mat-select id="implementType" [(ngModel)]="selectedImplementType"
                   [placeholder]="'Select Asset Definition' | translate | async" (selectionChange)="onImplementTypeSelected()"
                   
                    ngDefaultControl required>
                    <mat-option
                        *ngFor="let implementType of implementDefiTypeList"  [value]="implementType.Id">
                        {{implementType.Name}}
                    </mat-option>
                    <!-- <mat-option [value]="implementType.TemplateId"
                        *ngFor="let implementType of implementTypeList">
                          ngDefaultControl required [disabled]="newOrExistingOption=='2'">
                        {{implementType.TemplateName}}
                    </mat-option> -->
                </mat-select>
            </mat-form-field>

            <div *ngIf="newOrExistingOption=='1'" style="align-self: center; padding-right: 32px;">
                <a style="cursor: pointer;color: #5D7FF9;" (click)="SetupModelForImplement()"
                    title="Add New Implement Type">
                    <i class="material-icons button__icon" style="font-weight: bold;"> add</i></a>
            </div>


            <mat-form-field style="width: 100%">
                <mat-select id="selectedImplementModel" [(ngModel)]="selectedImplementModel"
                    [placeholder]="'Select Asset Model' | translate | async" ngDefaultControl>
                    <mat-option [value]="impMod.Id" *ngFor="let impMod of impModelList">
                        {{impMod.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
</div>
<div style="display: flex; flex-direction: row;margin-top: 1%;">

            <mat-form-field style="width: 100%" *ngIf="Capacity==true">
                <input matInput [placeholder]="'Implement Capacity' | translate | async" id="bucketCapacity" type="number"
                    [(ngModel)]="bucketCapacity" ngDefaultControl>
                <span matSuffix>m³</span>
            </mat-form-field>

            <mat-form-field style="width: 100%" *ngIf="GETType==true">
                <mat-select id="selectedGETType" [(ngModel)]="selectedGETType"
                    [placeholder]="'Select GET Type' | translate | async" ngDefaultControl>  
                    <mat-option [value]="make.Id" *ngFor="let make of makeList">
                        {{make.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>



        </div>
    </div>

    <div style="display: flex; flex-direction: column ;width: 78%;">
        <span style=" font-weight: bold;">4. {{"Implement Details" | translate | async}} </span>  
        <div style="display: flex; flex-direction: row;margin-top: 1%;">
            <mat-form-field style="width: 100%" *ngIf="newOrExistingOption=='1'">
                <input matInput [placeholder]="'Implement Serial Number' | translate | async" id="serialNumber" type="text"
                    (blur)="validateImplementSerial()" [(ngModel)]="serialNumber" ngDefaultControl
                    required (keydown.space)="$event.preventDefault();">
            </mat-form-field>


            <ng-container *ngIf="newOrExistingOption=='2'">

                <mat-form-field style="width: 100%">
                    <mat-select id="attachedImplement" [(ngModel)]="selectedImplement"
                        [placeholder]="'Select Implement' | translate | async" (selectionChange)="onImplementSelected()" ngDefaultControl
                        required>
                        <mat-option value="0"></mat-option>
                        <mat-option [value]="impl.Id" *ngFor="let impl of implementList">
                            {{impl.Name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div *ngIf="newOrExistingOption=='2' && selectedImplement>0"
                    style="align-self: center; padding-right: 32px;">
                    <a style="cursor: pointer;color: #5D7FF9;"
                        (click)="EditImplementSerial(selectedImplement)" title="Edit Implement Serial">
                        <i class="material-icons button__icon" style="font-weight: bold;"> edit</i></a>
                </div>


            </ng-container>

            <mat-form-field style="width: 100%">
                <input matInput [placeholder]="'Additional Serial #' | translate | async" id="Additional_serial_num" type="text"
                    [(ngModel)]="Additional_serial_num" ngDefaultControl>
            </mat-form-field>


            <mat-form-field style="width: 100%">
                <mat-select id="make" [(ngModel)]="selectedMake" [placeholder]="'Implement Make' | translate | async"
                    ngDefaultControl>
                    <mat-option value="0"></mat-option>
                    <mat-option [value]="make.Id" *ngFor="let make of makeList">
                        {{make.Name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>


            

        </div>
    </div>

    <div style="display: flex; flex-direction: column ;width: 78%;">
        <span style=" font-weight: bold;">5. {{"Implement Budget" | translate | async}}</span>
        <div style="display: flex; flex-direction: row;margin-top: 1%;">

            <mat-form-field style="width: 100%">
                <input matInput id="budget" [placeholder]="'Budget at Setup' | translate | async" type="number"
                    [(ngModel)]="budgetHrs" ngDefaultControl>
                <span matSuffix>{{'Hours' | translate | async}}</span>
            </mat-form-field>

            <mat-form-field style="width: 100%" *ngIf="BCMSetup==true">
                <input matInput id="bcm" [placeholder]="'BCM at Setup' | translate | async" type="number" [(ngModel)]="bcmHrs"
                    ngDefaultControl>
                <span matSuffix>m³</span>
            </mat-form-field>
            <mat-form-field style="width: 100%" *ngIf="TonSetup==true">
                <input matInput id="ton" [placeholder]="'Implement Tons at Setup' | translate | async" type="number"
                    [(ngModel)]="tonHrs" ngDefaultControl>
                <span matSuffix>Tons</span>
            </mat-form-field>


        </div>
    </div>


    <div style="display: flex; flex-direction: column ;width: 78%;">
        <span style=" font-weight: bold;">6. {{"Implement Setup Date and Hours" | translate | async}}</span>
        <div style="display: flex; flex-direction: row;margin-top: 1%;">

            <mat-form-field style="width: 32%;">
                <input matInput [matDatepicker]="startDatePicker" [placeholder]="'Date of Setup' | translate | async"
                    [(ngModel)]="dateOfReading" (click)="startDatePicker.open()">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

           
            <mat-form-field style="width: 32%">
                <input matInput [placeholder]="'Hours on Implement at Setup' | translate | async" id="implementHours"
                    type="number" min="0" [(ngModel)]="implementHours"
                    (keypress)="ValidateNumberInputs($event)" ngDefaultControl required
                    [disabled]="!canChangeHoursAndDate">
                <span matSuffix>{{'Hours' | translate | async}}</span>
            </mat-form-field>

        </div>
    </div>

    <div style="display: flex; flex-direction: column ;width: 78%;">
        <span style=" font-weight: bold;">7. {{"Implement Cost" | translate | async}}</span>
        <div style="display: flex; flex-direction: row;margin-top: 1%;">

            <mat-form-field style="width: 32%;">
                <input matInput id="cost" [placeholder]="'Implement Purchased Cost' | translate | async" type="number" min="0"
                    [(ngModel)]="purchaseCost" ngDefaultControl>
                <span matPrefix>$</span>
            </mat-form-field>

        </div>
    </div>
<!--TT-5375--- Asked to hide thoese model selection -->
    <!-- <div style="display: flex; flex-direction: column ;width: 78%;">
        <span style=" font-weight: bold;">7. Select Models to Which this is Applicable</span>
        <div style="display: flex; flex-direction: row;margin-top: 1%;" style="width: 100%;">

            <div *ngIf="equipmentOrInventory!='3'" style="width: 100%;">

                <div class="question">
                    <div class="question__text">Select all models this Implement fits</div>
                    <div>
                        <div class="question__control flex-container row"
                            style="justify-content: space-between;">
                            <div style="    min-width: 50%; max-width: 40%;">
                                <div class="labellist">Family</div>
                                <div style="min-width: 40%;">
                                    <mat-chip-list #chipList>
                                        <mat-chip *ngFor="let item of filteredFamilyList"
                                            [selectable]="selectable" [removable]="removable"
                                            (removed)="removeFamily(item)">
                                            {{item.Name}}
                                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                        </mat-chip>

                                    </mat-chip-list>
                                </div>
                                <mat-selection-list #types class="matlist" [(ngModel)]="selectedFamilyList" style="min-width: 50%;"
                                    (selectionChange)="onSelectionFamily($event, types.selectedOptions.selected)">
                                    <mat-list-option
                                        *ngFor="let type of _favouriteDialogService.availableFamilyList"
                                        [value]="type.Id">
                                        {{type.Name}}
                                    </mat-list-option>
                                </mat-selection-list>
                            </div>

                            <div style=" min-width: 50%;">
                                <div class="flex-container row" style="    justify-content: space-between">
                                    <div class="labellist">Available Models</div>
                                    <div class="labellist">Selected Models</div>
                                </div>
                                <dual-list key="Id" display="Name" [source]="source" [(destination)]="target"
                                    class="duallist">
                                </dual-list>
                            </div>

                        </div>

                        <div style="    min-width: 50%; max-width: 40%;">
                            <div class="labellist">Make</div>
                            <div style="min-width: 40%;">
                                <mat-chip-list #chipList>
                                    <mat-chip *ngFor="let item of filteredMakeList" [selectable]="selectable"
                                        [removable]="removable" (removed)="removeMake(item)">
                                        {{item.Name}}
                                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                    </mat-chip>

                                </mat-chip-list>
                            </div>

                            <mat-selection-list #makes class="matlist" [(ngModel)]="selectedMakeList" style="min-width: 50%;"
                                (selectionChange)="onSelectionMake($event, makes.selectedOptions.selected)">
                                <mat-list-option *ngFor="let make of makeList" [value]="make.Id">
                                    {{make.Name}}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>




                    </div>
                </div>


            </div>


            <div *ngIf="equipmentOrInventory=='3'"> 

                <div class="question">
                    <div class="question__text">Select all models this Implement fits</div>
                    <div style="pointer-events: none; opacity: 0.5;">
                        <div class="question__control flex-container row"
                            style="justify-content:space-between;">
                            <div style="    min-width: 40%;  max-width: 40%;">
                                <div class="labellist">Family</div>
                                <div style="min-width: 40%;">
                                    <mat-chip-list #chipList>
                                        <mat-chip *ngFor="let item of filteredFamilyList"
                                            [selectable]="selectable" [removable]="removable"
                                            (removed)="removeFamily(item)">
                                            {{item.Name}}
                                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                        </mat-chip>

                                    </mat-chip-list>
                                </div>
                                <mat-selection-list #types class="matlist" [(ngModel)]="selectedFamilyList"
                                    (selectionChange)="onSelectionFamily($event, types.selectedOptions.selected)">
                                    <mat-list-option
                                        *ngFor="let type of _favouriteDialogService.availableFamilyList"
                                        [value]="type.Id">
                                        {{type.Name}}
                                    </mat-list-option>
                                </mat-selection-list>
                            </div>

                            <div style=" min-width: 50%;">
                                <div class="flex-container row" style="    justify-content: space-between">
                                    <div class="labellist">Available Models</div>
                                    <div class="labellist">Selected Models</div>
                                </div>
                                <dual-list key="Id" display="Name" [source]="source" [(destination)]="target"
                                    class="duallist">
                                </dual-list>
                            </div>

                        </div>

                        <div style="    min-width: 40%;
                        max-width: 40%;">
                            <div class="labellist">Make</div>
                            <div style="min-width: 40%;">
                                <mat-chip-list #chipList>
                                    <mat-chip *ngFor="let item of filteredMakeList" [selectable]="selectable"
                                        [removable]="removable" (removed)="removeMake(item)">
                                        {{item.Name}}
                                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                    </mat-chip>

                                </mat-chip-list>
                            </div>

                            <mat-selection-list #makes class="matlist" [(ngModel)]="selectedMakeList"
                                (selectionChange)="onSelectionMake($event, makes.selectedOptions.selected)">
                                <mat-list-option *ngFor="let make of makeList" [value]="make.Id">
                                    {{make.Name}}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>




                    </div>
                </div>


            </div>
        </div>
    </div> -->

    <div class="button-container">
        <!--<button mat-raised-button color="warn" (click)="SaveorUpdateImplementCreate()">Save</button>-->
        <button *ngIf="selectedImplement > 0" mat-raised-button (click)="skipChanges()">{{'Skip Changes & Go To Next' | translate | async}}</button>
        <button mat-raised-button color="warn" [disabled]="loading" [class.loading]="loading" (click)="GotoComponentSetup()">{{'Save Changes & Go To Next' | translate | async}}</button>
    </div>
</div>
</div>
